import { useMemo } from "react";
import { useSelector } from "react-redux";
import { FlightSearchSelectors } from "@b2bportal/core-flights";
import { useI18nContext } from "@hopper-b2b/i18n";
import dayjs from "dayjs";
import { PackageSearchSelectors } from "@/store/packages/selectors";

interface RouteInfo {
  origin: string;
  destination: string;
  date: string;
}

export const usePackageFlightReturnPageHeader = () => {
  const { t } = useI18nContext();

  const returnDate = useSelector(FlightSearchSelectors.getReturnDate);

  // Grab origin and destination from package context
  const packageOrigin = useSelector(PackageSearchSelectors.getSearchFormOrigin);
  const packageDestination = useSelector(
    PackageSearchSelectors.getSearchFormDestination
  );

  const packageOriginLabel = packageOrigin?.label ?? "";
  const packageDestinationLabel = packageDestination?.label ?? "";

  const routeInfo: RouteInfo = useMemo(() => {
    return {
      origin: packageDestinationLabel,
      destination: packageOriginLabel,
      date: dayjs(returnDate).format("MMM D"),
    };
  }, [packageOriginLabel, packageDestinationLabel, returnDate]);

  return {
    title: t("core-packages.flights.returnTitle"),
    routeInfo,
  };
};
